import React from 'react';
import { getWebGroupProductPricesAsync } from '../../../actions/DataActionExtension.g';
import { IGetWebGroupProductPricesResponse, IWebGroupProductEntity, IWebGroupProductPrices } from '../../../actions/DataServiceEntities.g';
import { ICallerContext } from '@msdyn365-commerce/retail-proxy';

interface PriceInfoProps {
    itemId: string;
    context: ICallerContext;
    singleProduct?: boolean;
    product: IWebGroupProductEntity;
    selectedVariant: number;
}

export const PriceInfo: React.FC<PriceInfoProps> = props => {
    const { context, singleProduct, product, itemId, selectedVariant } = props;
    const [showPrices, setShowPrices] = React.useState(false);
    const [pricesLoading, setPricesLoading] = React.useState(true);
    const [fetchedPrices, setFetchedPrices] = React.useState<IWebGroupProductPrices[]>();
    const [selectedPrices, setSelectedPrices] = React.useState<IWebGroupProductPrices>();
    const [error, setError] = React.useState(false);
    // const zero = '0.00 Ea (0.00)';

    const getPrices = () => {
        if (!fetchedPrices) {
            void getProductPrices(String(itemId));
        } else {
            setProductPrice(fetchedPrices);
        }
    };
    const getProductPrices = async (itemId: string): Promise<void> => {
        await getWebGroupProductPricesAsync({ callerContext: context }, itemId)
            .then((data: IGetWebGroupProductPricesResponse) => {
                setFetchedPrices(data.WebGroupProductPrices);
                setProductPrice(data.WebGroupProductPrices);
            })
            .catch(error => {
                setError(true);
            })
            .finally(() => {
                setPricesLoading(false);
            });
    };
    const setProductPrice = (prices: IWebGroupProductPrices[] | undefined): void => {
        let selectedPrice;
        if (product.ProductVariant === selectedVariant) {
            selectedPrice = prices?.find(p => p.InventDimId === product.InventDimId);
        } else {
            selectedPrice = prices && prices[0];
        }
        setSelectedPrices(selectedPrice);
        setShowPrices(true);
    };
    const renderPrice = (priceLable: string | undefined, salesPrice: number | undefined): React.ReactNode | null => {
        if (!/^0\.00.*\(0\.00\)$/.test(priceLable ?? '') && salesPrice) {
            return (
                <div>
                    {priceLable}: {salesPrice.toFixed(4)}
                </div>
            );
        }
        return null;
    };

    return (
        <div className={singleProduct ? 'pricing-info single' : 'pricing-info'}>
            <a href='#' className='dollar' onMouseEnter={getPrices}>
                $
            </a>
            <div className={showPrices ? 'info-bubble show' : 'info-bubble'}>
                {pricesLoading ? <span className='loader'></span> : null}
                {error ? 'Price data not available' : ''}
                {renderPrice(selectedPrices?.PriceLabelOne, selectedPrices?.SalesPriceOne)}
                {renderPrice(selectedPrices?.PriceLabelTwo, selectedPrices?.SalesPriceTwo)}
                {renderPrice(selectedPrices?.PriceLabelThree, selectedPrices?.SalesPriceThree)}
                {renderPrice(selectedPrices?.PriceLabelFour, selectedPrices?.SalesPriceFour)}
            </div>
        </div>
    );
};
